import BaseService from './BaseService';

class RegisterService extends BaseService {
  /**
   * Fetch
   * @return {Promise}
   */
  fetch = () => {
    const config = {
      url: '/register',
    };
    return this.doRequest(config);
  };

  checkAvailability = (name) => {
    const config = {
      url: `/register/characternameavailable?characterName=${name}`,
    };
    return this.doRequest(config);
  };


  /**
   * Register
   * @param  {Object} data
   * @return {Promise}
   */
  emailRegister = (data = {}) => {
    const config = {
      method: 'post',
      url: '/register/emailregisteruser',
      data,
    };
    return this.doRequest(config);
  };


  /**
   * Create Character
   * @param  {Object} data
   * @return {Promise}
   */
  createCharacter = (data = {}) => {
    const config = {
      method: 'post',
      url: '/register/createcharacter',
      data,
    };
    return this.doRequest(config);
  };
}

export { RegisterService as default };
